import classList from '../utils/classList';
import Component from '../Component';
export default class Icon extends Component {
  view(vnode) {
    const {
      name,
      ...attrs
    } = vnode.attrs;

    // @ts-ignore
    attrs.className = classList('icon', name, attrs.className);
    return m("i", Object.assign({
      "aria-hidden": "true"
    }, attrs));
  }
}
flarum.reg.add('core', 'common/components/Icon', Icon);